import React from "react";
import CatalogCheckbox from "./CatalogCheckbox";
import CustomSelect from "../shared/CustomSelect";
import CatalogOrderOptions from "./CatalogOrderOptions";
import KeyDropdownValue from "../shared/KeyDropdownValue";
const CatalogOptions = ({
  campaign,
  optionState,
  optionActions,
  defaultValues,
  onBrandChange,
  brands,
  selectedBrand,
  generateFilterActions,
  generateFilterState,
}) => {

  const { firstTaxon, secondTaxon, thirdTaxon } = optionState();
  const {
    changeFirstTaxons,
    changeSecondTaxons,
    changeThirdTaxons,
  } = optionActions();

  const {
    selectedFirstTaxon,
    selectedSecondTaxon,
    selectedThirdTaxon,
  } = defaultValues();
  

  return (
    <div className="catalog-options">
      <div className="catalog-options-container">
        <KeyDropdownValue
          name={"catalog-options-brand-select"}
          isClearable
          onChange={onBrandChange}
          options={brands}
          optionsLabel={"name"}
          optionsId={"id"}
          defaultValue={selectedBrand}
          title="Marcas"
          placeholder="Selecione"
          classNames="catalog-options-select"
          noMessage={"Sem resultados"}
        />
        {firstTaxon.length > 1 && (
          <KeyDropdownValue
            name={"catalog-options-first-taxon-select"}
            isClearable
            onChange={changeFirstTaxons}
            options={firstTaxon}
            optionsLabel={"name"}
            optionsId={"id"}
            defaultValue={selectedFirstTaxon}
            title="Prémios"
            placeholder="Selecione"
            classNames="catalog-options-select"
            noMessage={"Sem resultados"}
          />
        )}
        <KeyDropdownValue
          name={"catalog-options-second-taxon-select"}
          isClearable
          onChange={changeSecondTaxons}
          options={secondTaxon}
          optionsLabel={"name"}
          optionsId={"id"}
          defaultValue={selectedSecondTaxon}
          title="Categorias"
          placeholder="Selecione"
          classNames="catalog-options-select"
          noMessage={"Sem resultados"}
        />
        <KeyDropdownValue
          name={"catalog-options-third-taxon-select"}
          isClearable
          onChange={changeThirdTaxons}
          options={thirdTaxon}
          optionsLabel={"name"}
          optionsId={"id"}
          defaultValue={selectedThirdTaxon}
          title="Sub-categoria"
          placeholder="Selecione"
          classNames="catalog-options-select"
          noMessage={() => "Sem resultados"}
        />
      </div>
    </div>
  );
};

export default CatalogOptions;
